import { TOP, BOTTOM, LEFT, RIGHT, AUTO, DEFAULT_SHAPE_HEIGHT, DEFAULT_SHAPE_WIDTH, DEFAULT_SHAPE_MINHEIGHT, DEFAULT_SHAPE_MINWIDTH, DEFAULT_SHAPE_POSITION, DEFAULT_SHAPE_TYPE } from '../constants.js';
import { simpleExtend } from '../utils/functions.js';

const DefaultConnectors = [{
        name: TOP
    }, {
        name: BOTTOM
    }, {
        name: LEFT
    }, {
        name: RIGHT
    }, {
        name: AUTO,
        position: function (shape) {
            return shape.getPosition('center');
        }
    }];
const shapeDefaults = function (extra) {
    const defaults = {
        type: DEFAULT_SHAPE_TYPE,
        path: '',
        autoSize: true,
        visual: null,
        x: DEFAULT_SHAPE_POSITION,
        y: DEFAULT_SHAPE_POSITION,
        minWidth: DEFAULT_SHAPE_MINWIDTH,
        minHeight: DEFAULT_SHAPE_MINHEIGHT,
        width: DEFAULT_SHAPE_WIDTH,
        height: DEFAULT_SHAPE_HEIGHT,
        hover: {},
        editable: {
            connect: true,
            tools: []
        },
        connectors: DefaultConnectors,
        rotation: {
            angle: 0
        }
    };
    simpleExtend(defaults, extra);
    return defaults;
};

export { DefaultConnectors, shapeDefaults };
